<template>
    <div>
        <buttonlist @help="help" @reflash="reflash" @save="save" ref="SetBtn"></buttonlist>
        <div>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[97]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>
                <tr>                    
                    <td style="width:50px">{{$t('getapi[2952]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.purreq_createperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="prselectperson(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[2788]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.purreq_auditperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="prselectperson(2)"></i>
                        </el-input>
                    </td>
                    
                </tr>               
            </table>
            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[101]')}}</el-divider>
                    </td>
                </tr>
            </table>
            <table>
                <tr>                    
                    <td style="width:50px">{{$t('getapi[2952]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.purorder_createperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="pocreateperson(1)"></i>
                        </el-input>
                    </td>
                    <td style="width:50px">{{$t('getapi[2788]')}}</td>
                    <td style="width:150px">
                        <el-input
                                v-model="dataDetail.purorder_auditperson"
                                type="text"
                                readonly
                                size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="pocreateperson(2)"></i>
                        </el-input>
                    </td>
                </tr>        
            </table>
           
        </div>
        
        <div>

            <table>
                <tr>
                    <td colspan="4">
                        <el-divider content-position="left">{{$t('getapi[13538]')}}</el-divider>
                    </td>
                </tr>
            </table>

            <div class="btnnowrap">
                <el-button type="primary"  @click="additem('')" size="mini" >{{ $t('getapi[878]') }}</el-button>
                <el-button type="primary"  size="mini" @click="delpart" >{{$t('getapi[3889]') }}</el-button>
            </div>
            <!-- 表格 -->
            <el-table
                    :data="dataDetail.Lists"
                    v-loading="loading"
                    :highlight-current-row="false"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight - 215"
                    tab-click="selectInfo(0)"
                    header-row-class-name="headerclass"
                    @selection-change="handleSelectionChange_Ecnper"
                    style="width: 65%; margin-top:0px"
                    :header-cell-style="$limits.headerClass"
            >
                <el-table-column type="selection" align="center" width="20"></el-table-column>
                <el-table-column show-overflow-tooltip prop="config_code" :label="$t('getapi[3367]')" width="100"></el-table-column>
                <el-table-column prop="config_value" align="center" :label="$t('getapi[13539]')">
                    <template scope="scope">
                        <el-input type="text" v-model="scope.row.config_value"></el-input>
                    </template>
                </el-table-column>
                <!-- <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')" width="200"></el-table-column> -->
                <!-- <el-table-column show-overflow-tooltip prop="config_value" :label="$t('getapi[13539]')" width="500"></el-table-column> -->
            </el-table>
        </div>
       
        
   
        <!--发料 保管员 记账员-->
        
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getpocreateperson" ref="pocreateperson"></selector><!--保管员 记账员-->
        <!-- <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector> -->
        <!-- 获取人员列表 -->
        <selector :isVisible="false" :isBatch=false :selectType="7" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getprperson" ref="prperson"></selector><!--保管员 记账员-->
      
        
        <!-- <selector :isVisible="ItemVisible" :isBatch=true :selectType="0" :isSplitPage=true
            :postUrl="'/Basic/GetENGITEMList'" @callback="getItemlist" ref="setitemlist"></selector> -->


            <selector :isVisible="ItemVisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'Basic/GetENGITEMList'" @callback="getItemlist" ref="setitemlist"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'automctoprtopur',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                dataDetail: {                    
                    purorder_createpersoncode:'',//采购订单创建人code,
                    purorder_createperson:'',//采购订单创建人,
                    purorder_auditpersoncode:'',//采购订单审核人code,
                    purorder_auditperson:'',//采购订单审核人,
                    purreq_createpersoncode:'',//采购计划创建人,
                    purreq_createperson:'',//采购计划创建人,
                    purreq_auditpersoncode:'',//采购计划审核人,
                    purreq_auditperson:'',//采购计划审核人,
                    Lists:[]
                  },
                currencyList: [],
                rateList: [],
                currency_name: '',
                tax_rate: '',
                popersontype: 1, // 人员类型 1：保管员2：记账员
                issueDeptType: [], // 领料部门数组
                cargoVisible:false, 
                prpersontype:1,//pr工单人员类型 1 创建人、2 下达人
                checkpersontype:1,//检验人员类型 1 成品检验 、2 成品报检人 
                ItemLists:[],
                ItemVisible:false,
                selectData:[],
                loading: false, // 主表加载状态
            };
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            // that.currencyList = Array.methods.getCurrencyList();
            that.issueDeptType = Array.methods.getIssueDeptWithPFLAG();
            that.getView();
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1119]"),this.$t("getapi[11]"));
            },
            //权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('save,refresh');
            },
            getView() {
                let that = this;
                let data = '';
                that.$http.urlpost('/MRP/Tool/GetMrpAutoTranOrderConfig', data, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            additem(val){                
                let that = this;
                that.ItemVisible = true;
                that.$refs.setitemlist.clearInput(that.ItemVisible, null);
            },            
            getItemlist(data){
                let that = this;
                let arr = data.filter(item => {
                    return that.dataDetail.Lists.every(item2 => {
                        return item.ITEM_CODE != item2.config_code;
                    });
                });
                data=arr;
                for (let i = 0; i < data.length; i++) {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                config_code:data[i].ITEM_CODE,
                            }
                        ];
                    }
            },
            handleSelectionChange_Ecnper(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            // 导出
            save() {
                let that = this;
                let parm = that.dataDetail;
                that.$http.urlpost('/MRP/Tool/SaveSysProdAutoConfig', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            delpart() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.PartLists.splice(that.selectData[i].index, 1);
                            if (that.selectData[i].exclusively_id!=0) {
                                let datatmp = {
                                    relation_ecn_no: that.selectData[i].relation_ecn_no,
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Eng/ECN/DelEcnPart', parm, function (res) {
                             
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            pocreateperson(val){
                //po
                let that = this;
                that.popersontype = val
                that.$refs.pocreateperson.clearInput(true);
            },
            getpocreateperson(data){
                //
                let that = this
                if(that.popersontype == 1){
                    that.dataDetail.purorder_createperson = data.name
                    that.dataDetail.purorder_createpersoncode = data.code
                } else if(that.popersontype == 2){
                    that.dataDetail.purorder_auditperson = data.name
                    that.dataDetail.purorder_auditpersoncode = data.code
                }
            },
            prselectperson(val){
                //pr单人员
                let that = this;
                that.prpersontype = val
                that.$refs.prperson.clearInput(true);                
            },
            getprperson(data){
                //pr单人员
                let that = this
                if(that.prpersontype == 1){
                    that.dataDetail.purreq_createperson = data.name
                    that.dataDetail.purreq_createpersoncode = data.code
                } else if(that.prpersontype == 2){
                    that.dataDetail.purreq_auditperson = data.name
                    that.dataDetail.purreq_auditpersoncode = data.code
                }
            },
           
             
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
